import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const STATUS = { nova: "Nova", respondida: "Respondida", arquivada: "Arquivada" };

const fmt = (iso) => new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });

const AdminMessages = () => {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("nova");

    const load = async () => setItems((await api.get("/messages")).data);
    useEffect(() => {
        load();
    }, []);

    const setStatus = async (id, status) => {
        await api.patch(`/messages/${id}`, { status });
        await load();
    };

    const remove = async (id) => {
        if (!window.confirm("Excluir esta mensagem definitivamente?")) return;
        await api.delete(`/messages/${id}`);
        await load();
    };

    const shown = items.filter((m) => !filter || m.status === filter);

    return (
        <main data-testid="admin-messages" className="max-w-3xl mx-auto px-6 py-14">
            <div className="flex flex-wrap gap-3 mb-10">
                {[["nova", "Novas"], ["respondida", "Respondidas"], ["arquivada", "Arquivadas"], ["", "Todas"]].map(([k, l]) => (
                    <button key={l} type="button" data-testid={`messages-filter-${k || "todas"}`} onClick={() => setFilter(k)} className={`font-sans text-[11px] uppercase tracking-[0.16em] px-4 py-2 border rounded-full transition-colors ${filter === k ? "border-[#C7A659] text-[#C7A659]" : "border-[#234135] text-[#7E8978] hover:text-[#EAEAE6]"}`}>
                        {l} ({k ? items.filter((m) => m.status === k).length : items.length})
                    </button>
                ))}
            </div>
            {shown.length === 0 && <p data-testid="messages-empty" className="font-sans font-light text-[14px] text-[#7E8978]">Nenhuma mensagem.</p>}
            <ul className="flex flex-col">
                {shown.map((m) => (
                    <li key={m.id} data-testid={`message-${m.id}`} className="border-b border-[#1B3025] py-7">
                        <p className="text-[10px] uppercase tracking-[0.2em] text-[#7E8978] font-sans">{fmt(m.created_at)} · {STATUS[m.status]}</p>
                        <h3 className="mt-2 font-serif text-[20px] text-[#EAEAE6]">{m.subject}</h3>
                        <p className="mt-1 font-sans text-[13px] text-[#B0B6A6]">
                            {m.name} · <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`} className="text-[#C7A659] hover:underline">{m.email}</a>
                        </p>
                        <p className="mt-4 font-sans font-light text-[14px] leading-relaxed text-[#D7D1BF] whitespace-pre-wrap">{m.message}</p>
                        <div className="mt-5 flex gap-4">
                            {Object.entries(STATUS).filter(([k]) => k !== m.status).map(([k, l]) => (
                                <button key={k} type="button" data-testid={`message-${m.id}-set-${k}`} onClick={() => setStatus(m.id, k)} className="font-sans font-light text-[11px] uppercase tracking-[0.1em] text-[#B0B6A6] hover:text-[#EAEAE6]">
                                    marcar como {l.toLowerCase()}
                                </button>
                            ))}
                            <button type="button" data-testid={`message-${m.id}-delete`} onClick={() => remove(m.id)} className="font-sans font-light text-[11px] uppercase tracking-[0.1em] text-[#a86a5a] hover:text-[#EAEAE6]">excluir</button>
                        </div>
                    </li>
                ))}
            </ul>
        </main>
    );
};

export default AdminMessages;
